export const onInitialClientRender = () => {
  const style = document.createElement("style");
  style.innerHTML = `
    [data-slate-editor] { 
      -webkit-user-modify: read-write !important; 
    }
  `;
  document.head.appendChild(style);
};
